import { PLAY_REPEAT } from "constant/panel";

export const repeatIsLoop = (repeat: any): boolean => {
  return repeat === PLAY_REPEAT.LOOP;
};

export const repeatIsSingle = (repeat: any): boolean => {
  let check: boolean = true;
  if (typeof repeat !== "undefined") {
    if (typeof repeat === "number") {
      if (repeat > 0) {
        check = false;
      }
    } else if (repeat === PLAY_REPEAT.LOOP) {
      check = false;
    }
  }

  return check;
};

export const repeatIsTimes = (repeat: any): boolean => {
  let check: boolean = false;
  if (typeof repeat === "number") {
    if (repeat > 0) {
      check = true;
    }
  }

  return check;
};
